import type { SVGProps } from 'react';
const SvgVerticalSplitter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1"
    height="30"
    viewBox="0 0 1 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line x1="0.5" y1="0.5" x2="0.500001" y2="29.5" stroke={props.color ? props.color : '#ACACAC'} />
  </svg>
);
export default SvgVerticalSplitter;
